import { Message } from './index';

const englishMessages: Message = {
  resources: {
    contracts: {
      _error: 'Error opening contract',
      name: 'Contract |||| Contracts',
      title: 'Contract %{id} %{deceasedClientName}',
      funeral: 'Funeral of',
      contact: 'Contact',
      new: 'New',
      primary_client_required: 'Primary Client is required',
      convert: 'Convert to At-Need',
      fields: {
        id: 'ID',
        service_id: 'Service ID',
        deceased_client_id: 'Deceased',
        description: 'Description',
        issue_date: 'Issue date',
        client_id: 'Client',
        memo: 'Memo',
        created_at: 'Created',
        total_amount: 'Total amount',
        category: 'Category',
        item: 'Item',
        price: 'Price',
        quantity: 'Quantity',
        provincial_tax: 'Provincial tax',
        federal_tax: 'Federal tax',
        tax: 'Tax',
        total: 'Total',
        subTotal: 'SubTotal',
        signed_contract: 'Signed contract',
      },
      lines: {
        name: 'Services and products',
      },
      search: {
        client: 'Primary Client',
        deceased_client: 'Deceased',
      },
      tabs: {
        payments: 'Payments',
      },
      print: {
        agreement: 'Funeral Services Contract',
        to: 'To',
        prearrangement: 'Pre-Arrangement',
        gst: 'GST',
        pst: 'QST',
        contractNumber: 'Contract No',
        serviceNumber: 'Service No',
        date: 'Date',
        beneficiary: 'Beneficiary',
        name: 'Name',
        birthdate: 'Birthdate',
        address: 'Address',
        telephone: 'Telephone',
        email: 'Email',
        buyer: 'Buyer',
        if_buyer_different: '(If different from beneficiary)',
        funeral_services: 'FUNERAL SERVICES',
        services_and_fees: 'SERVICES AND FACILITY FEES',
        basic_fees_title: 'Professional Guidance and Support:',
        basic_fees_description:
          'The fee for the basic services of our funeral directors, professional staff and general staff includes, availability on a 24-hour basis, funeral arrangement meeting, coordination with family, clergy and cemetery, all details associated with or related to the preparation and filing of government documents and notices, supervision & overview of funeral service & burial, aftercare support and guidance.',
        religious_services: 'RELIGIOUS SERVICES',
        halachic: 'Halachic Requirements',
        transportation_services: 'TRANSPORTATION SERVICES',
        total_a: 'TOTAL SERVICES (A)',
        goods: 'GOODS',
        total_b: 'TOTAL GOODS (B)',
        total_c: 'TOTAL DISBURSEMENTS (C)',
        subtotal_a_b: 'SUBTOTAL (A+B)',
        cost_with_taxes: 'SUBTOTAL WITH TAXES (A+B)',
        total: 'TOTAL WITH TAXES (A+B+C)',
        total_no_c: 'TOTAL WITH TAXES (A+B)',
        disbursements: 'DISBURSEMENTS*',
        summary: 'SUMMARY',
        signature: 'Signature',
        initials: 'Initials',
        print_name: 'Print Name',
        see_back: 'SEE OVERLEAF',
        page1_disbursements:
          '*The Buyer hereby appoints the Seller as its agent in connection with the acquisition of the various goods and services listed in the "Disbursements" section above and the Buyer agrees to reimburse the Seller for amounts paid by the Seller on its behalf.',
        page2_1:
          'The Contract constitutes the entire agreement between the Buyer(s) and Paperman & Sons Inc. (the “Seller”) pertaining to the subject matter hereof.',
        page2_1_pn:
          'The Contract constitutes the entire agreement between the Buyer, the Beneficiary, and Paperman & Sons Inc. (the “Seller”) pertaining to the subject matter hereof.',
        page2_2_pn:
          'The Buyers, and the Beneficiary, hereby agree to act solidarily (jointly and severally) towards all obligations pertaining to the Contract. In all cases, the Buyer, and the Beneficiary, expressly bind themselves and their respective estates for the payment of all amounts due under the Contract',
        page2_2:
          'If there is more than one Buyer, the Buyers hereby agree to act solidarily (jointly and severally) towards all obligations pertaining to the Contract. In all cases, the Buyer(s) expressly agree to be bound for the payment of all amounts due under the Contract', 
        page2_3:
          'If there is more than one Buyer, all references herein to a single Buyer shall be read in the plural and all provisions of the Contract apply to all of the Buyers.',
        page2_4:
          'The Buyer hereby certifies to have the requisite authority to express the wishes pertaining to the nature of the funeral and the disposal of the body of the Deceased in accordance with section 42 of the Civil code of Québec. Except as otherwise provided for in the law, the Buyer agrees to be fully liable and be held responsible for any act taken by the Seller following the instructions received from a Buyer without the proper authority. The Buyer hereby expressly releases the Seller from any and all liability which may accrue from an action taken from those having the proper authority to instruct the Seller.',
        page2_5:
          'The “TOTAL WITH TAXES” is immediately payable in full at the signature of the Contract. Any amount unpaid when due will bear interest at the rate of 1% per month or 12% per year.',
        page2_6:
          'The Seller is not held to any obligations until the total amount payable under Clause 5 of the Contract is received by the Seller.',
        page2_6_pn:
          'The Seller is not held to any obligations until the total amount payable under Clause 6 of the Contract is received by the Seller.',  
        page2_7:
          'The Buyer shall be held liable to the Seller for all third party disbursements paid or contracted for by the Seller in connection with the funeral of the Deceased. If there is more than one Buyer, the Buyers shall be held solidarily (jointly and severally) liable towards the Seller for all third party disbursements to be incurred by the Seller in connection with the funeral of the Deceased. All third party disbursements are subject to change. All third party disbursements must be paid by the Buyer(s) at the time of the funeral of the Deceased.',
        page2_8:
          "The Seller shall not be liable for delay or failure to perform any obligations if such delay or failure in performing all or any of its obligations under the Contract arises out of causes beyond its control without its fault or negligence, including without limitation acts of God, war (declared and undeclared), civil commotions, revolutions, blockades, acts of the public enemy, acts of terrorism, acts of government, epidemic, pandemic, guarantee restrictions, strikes, walk-outs, slow-downs, labour disputes, embargoes, unusually severe weather, unreliable or insufficient supply of power or other utilities or resources, transportation delays and financial distress or failure, including, without limitation, insolvency or bankruptcy of a substantial or key supplier, sub-consultant or subcontractor of the Seller.",
        page2_9:
          'At the time of the funeral, the Seller may, at its discretion, provide substitute goods and services of equal or of superior quality, as determined by the Seller in its sole discretion.',
        page2_10:
          'The Buyer received written proof of the computerized consultation of the Register of prearranged funeral services contracts by the Seller. To that extent, the Buyer provided the Seller with the information needed to complete the required computerized search.',
        page2_11:
          'All monetary amounts expressed in the Contract are Canadian dollars, except if otherwise provided for by the Parties.',
        page2_12: 'The Contract is governed by the laws of the Province of Qu��bec.',
        page2_13: 'The Buyer recognizes having been provided with a French version of the Contract. The Parties hereby express their intention to have the Contract and all other related documents drawn up in English.',
        page2_14: 'L’Acheteur reconnait avoir reçu une version du Contrat en français. Les Parties expriment par la présente leur intention de faire rédiger le Contrat et tous les autres documents y afférents en anglais.',
        page_2_PN_4: 'The Seller is hereby authorized to direct the funeral of the Beneficiary. In accordance with art. 42 of the Code civil du Québec, the Beneficiary hereby expresses their wishes to have a funeral held in the manner expressed herein. For greater certainty, the Beneficiary wishes to have a funeral held in the manner expressed herein with the goods and services specifically contracted for, or of greater quality or in greater number. Any instruction received from the heirs, successors or estate trustees of the Beneficiary having the effect of reducing, in quality or in number, the goods and services provided for under the Contract are contrary to the expressed wishes of the Beneficiary and may be disregarded by the Seller. The Buyer hereby acknowledges having received the expression of the Beneficiary’s latest wishes to have a funeral held in the manner expressed herein.',
        page_2_PN_5: 'The Beneficiary may revoke, terminate or amend the expressed wishes herein at any time during the lifetime of the Beneficiary. The Beneficiary or the Buyer may terminate or amend the Contract at any time during the lifetime of the Beneficiary, subject to the terms herein and the applicable penalties provided for under the law. However, after the death of the Beneficiary, the Beneficiary and the Buyer expressly agree that no changes to the Contract may have the effect of reducing the total amount payable hereunder, except as provided for in the Contract or the applicable legislation. If the Contract is revoked, terminated or amended a copy of the modified Contract must be sent to both the Beneficiary and the Buyer, or as the case may be, their heirs, successors or liquidators. Every contract modification is deemed to form part of the Contract.',
        page_2_PN_8: 'Disbursements to third parties in connection with the funeral of the Beneficiary are not included in the Contract and will be incurred and shall be payable at the time of the funeral at the prices and the tax rates then in effect. Such disbursements shall be payable by the Buyer or the Beneficiary’s estate, each of whom shall be solidarily (jointly and severally) liable with the other.',
        page_2_PN_9: 'All amounts of Goods and Services Tax (“GST”) and Québec Sales Tax (“QST”) collected under the Contract are calculated based on the prices and the rates in effect at the time of signature. In the event that subsequent to the date of the Contract, there is a change in the goods or services provided, the cost of the goods and services being changed plus GST and QST collected at the time of the Contract will be refunded. All newly contracted goods and services will be charged at the prices and the tax rates in effect.',
        page_2_PN_10: 'The Seller agrees to provide funeral services upon the death of the Beneﬁciary of the Contract insofar as the Seller is informed in sufficient time.',
        page_2_PN_12: 'At the time of the funeral, the Seller may, at its discretion, provide substitute goods and services of equal or of superior quality, as determined by the Seller in its sole discretion.',
        page_2_PN_13: 'If the Beneficiary, the Buyer or the third party designated to receive a copy of the Contract change their address, the Beneficiary or the Buyer must inform the Seller within ten (10) days of becoming aware of such change.',
        page_2_PN_16: 'The Beneficiary and the Buyer received written proof of the computerized consultation of the Register of prearranged funeral services contracts by the Seller. To that extent, the Beneficiary or the Buyer provided the Seller with the information needed to complete the required computerized search.',
        page_2_PN_17: 'The Beneficiary and the Buyer each recognize that they were provided with a French version of the Contract. The Parties hereby express their intention to have the Contract and all other related documents drawn up in English.',
        page_2_PN_17b: 'Le Bénéficiaire et l’Acheteur reconnaissent avoir reçu une version du Contrat en français. Les Parties expriment par la présente leur intention de faire rédiger le Contrat et tous les autres documents y afférents en anglais.',
        page_2_PN_18: 'In accordance with the Act respecting prearranged funeral services and sepultures, the Seller will send a copy of the Contract to the third party designated by the Beneficiary below, except if the Beneficiary instructs the Seller in the Contract otherwise.',
        governed_pn: 'This Contract is governed by the Act respecting prearranged funeral services and sepultures (Chapter A-23.001).',
        information_required_by_the_act: 'INFORMATION REQUIRED BY THE ACT RESPECTING ARRANGEMENTS FOR FUNERAL SERVICES AND SEPULTURES',
        seller_must_make: 'The seller must make available to the public, at all times and in each of his establishments, an up-to-date list of the prices of each item of goods and each service that he offers.',
        designated_person: 'Designated Third Person Name',
        or: 'OR',
        page2_release:'The Beneficiary releases the Seller from the obligation to send a copy of this Contract to a third party, declaring that the Beneficiary prefers that the Seller abstains from doing so.',
        page2_buyer: 'Buyer (signature required if exempt)',
        page3_header:
          'INFORMATION REQUIRED BY THE ACT RESPECTING ARRANGEMENTS FOR FUNERAL SERVICES AND SEPULTURES',
        page3_1:
          'Within ten (10) days of the conclusion of the Contract, the Seller must, unless exempted in writing by the Buyer, send a copy of the Contract to a person designated by the Buyer so that the latter is informed of the existence of the Contract.',
        page3_2a:
          'The Contract may be terminated in the following manner:',
        page3_2b:
          'If the Contract was solicited, negotiated or concluded ELSEWHERE than at the establishment of the Seller:',
        page3_2c:
          'A. It may be terminated free of charge and without penalty within thirty (30) days from the time the Buyer receives his copy of the Contract. Cancellation is done in either of two ways:',
        page3_2d:
          'i. by returning to the Seller or his representative, after having completed and signed it, the form entitled “Cancellation Form” which must be attached to the copy of the Contract;',
        page3_2e:
          'ii. by returning to the Seller or his representative a written notice indicating his intention to terminate the contract.',
        page3_2f:
          'B. After the thirty (30) day period, the Contract may also be terminated subject to a penalty. In this case, the Buyer will receive the capital indexed to the cost of living, less 10% of the price of goods and services not provided. The cancellation is done by sending a written notice to the Seller or his representative of his intention to terminate the Contract.',
        page3_2g:
          'If the Contract was solicited, negotiated and concluded AT the establishment of the Seller:',
        page3_2h:
          'It can be terminated at any time subject to a penalty. In this case, the Buyer will receive the capital indexed to the cost of living, less 10% of the price of goods and services not provided. The cancellation is done by sending a written notice to the Seller or his representative of his intention to terminate the Contract.',
        page3_3a:
          'The collection of payment as well as the supply of goods or services by the Seller are subject to the following rules:',
        page3_3b:
          'If the Contract was solicited, negotiated or concluded ELSEWHERE than at the establishment of the Seller:',
        page3_3c:
          'A. Seller cannot collect partial or full payment until the expiration of thirty (30) days from the time the Buyer receives his copy of the Contract. In addition, he cannot provide goods or services before the expiry of this period.',
        page3_3d:
          'B. After the thirty (30) day period, the Seller may collect payments and provide goods and services.',
        page3_3e:
          'If the contract was solicited, negotiated and concluded AT the establishment of the Seller:',
        page3_3f:
          'The Seller can collect payments upon signing the Contract and can also provide goods and services.', 
        page3_4:
          'The Seller must, within 45 days of collection, deposit in trust with a depositary (a bank, credit union, a trust company or another ﬁnancial institution) any amount he collects in full or partial payment of a Contract, except for an amount representing no more than 10% of the price of the goods and services that have not been provided. The Seller is not required to deposit any amount paid by the Buyer for goods or services provided before the expiry of the 45-day period.',
        page3_5:
          'The depositary must inform the Buyer in writing of the amount and date of the ﬁrst deposit in trust made for him by the Seller. This notice must be sent to the Buyer within 30 days of this ﬁrst deposit.',
        page3_6:
          'The Seller is prohibited from stipulating in a contract an indexation clause or any other clause intended to allow him to increase the price of the goods and services provided for in the Contract.',
        page3_7:
          'The Seller must make available to the public, at all times and at each of his establishments, an up-to-date list of the price of every good and every service it offers.',
       page3_box1:
          'Information required under the Act respecting arrangements for funeral services and sepultures',
        page3_box2:
          `This Contract contains the expression of the Beneficiary's wish respecting the nature of the Beneficiary's funeral or disposal of the Beneficiary's body, or both. An indication of the existence of the Contract will be entered in the register of prearranged funeral services contracts and prepurchased sepulture contracts.`,
        page3_box3:
          'In certain circumstances, the Beneficiary, the Buyer and their heirs, successors or liquidators, may modify or terminate this contract on the conditions set in the Acts and regulations in force. If the Beneficiary, the Buyer or their heirs, successors or liquidators terminate this contract, the amounts that the Seller holds in trust in accordance with the Act will be remitted to the Buyer, as the case may be, subject to the penalty the Seller may impose.',
        buyer_name: 'Buyer Name',
        buyer_signature: 'Buyer Signature',
        buyer_address: 'Buyer Address',
        buyer_or_beneficiary_name: 'Buyer/Beneficiary Name',
        beneficiary_name: 'Beneficiary Name',
        beneficiary_signature: 'Beneficiary Signature',
        beneficiary_address: 'Beneficiary Address',
        buyer_or_beneficiary_address: 'Buyer/Beneficiary Address',
        buyer_or_beneficiary_signature: 'Buyer/Beneficiary Signature',
        signed_outside: `If the Contract is signed outside of Seller's establishment`,
        seller_name_outside: 'Name of Seller’s representative',
        seller_address_outside: 'Address of Seller’s representative',
        seller_name: 'Seller Name',
        seller_signature: 'Seller Signature',
        signed_in: 'Signed In',
        page4_header:'CANCELLATION FORM',
        page4_subheader: '(Act respecting arrangements for funeral services and sepultures, Art. 5)',
        cancellation1:
        'Pursuant to the first paragraph of section 10 of the Act respecting funeral services and sepultures, I cancel the contract bearing the number ',
        contract_number: '(Contract number),',
        cancellation2: ' concluded on ',
        date_conclusion: 'Date when contract was made',
        at: 'at',
        place_conclusion: '(Place where contract was made)',
        casket: 'CASKET',
        religious_goods: 'RELIGIOUS GOODS',
        deceased: 'Deceased',
      },
    },
    clients: {
      name: 'Client |||| Clients',
      title: 'Client %{id} %{name}',
      gender: {
        male: 'Male',
        female: 'Female',
        other: 'Other',
      },
      fields: {
        id: 'ID',
        name: 'Name',
        address: 'Address',
        address2: 'Address 2',
        city: 'City',
        postal_code: 'Postal Code',
        province: 'Province',
        email: 'Email',
        birthdate: 'Birthdate',
        phone_number: 'Phone number',
        children: 'Children',
        firstName: 'First Name',
        lastName: 'Last Name',
        birthdate: 'Birth Date',
        isOver18: 'Over 18',
      },
      search: {
        name: 'Search in names',
      },
      connections: 'Connections',
      no_children: 'No children recorded',
    },
    categories: {
      name: 'Category |||| Categories',
      title: 'Category %{id} %{name}',
      fields: {
        name: 'Name',
        taxable: 'Taxable',
      },
    },
    items: {
      name: 'Item |||| Items',
      title: 'Item %{id} %{name}',
      fields: {
        category: 'Category',
        Name: 'Name',
        Description: 'Description',
        UnitPrice: 'Unit price',
        Active: 'Active',
        IncomeAccount: 'Income account',
        ExpenseAccount: 'Expense account',
        Type: 'Type',
        Taxable: 'Taxable',
      },
      types: {
        category: 'Category',
        inventory: 'Inventory',
        nonInventory: 'Non-inventory',
        service: 'Service',
      },
    },
    invoices: {
      name: 'Invoice |||| Invoices',
      pdf: 'Get invoice Pdf',
      pdf_success:
        'Success opening the invoice pdf from QuickBooks in a new tab',
      pdf_error: 'Error getting invoice pdf from QuickBooks',
      fields: {
        TxnDate: 'Issue date',
        DueDate: 'Due date',
        send_date: 'Send date',
        Balance: 'Balance owed',
        TotalAmt: 'Total amount',
        PrintStatus: 'Print status',
        EmailStatus: 'Email status',
        GlobalTaxCalculation: 'Global tax calculation',
      },
      print: {
        invoice: 'INVOICE',
        invoice_number: 'Invoice No',
        invoice_date: 'Invoice Date',
        service: 'Service',
        service_number: 'Service No',
        interest: 'INTEREST',
        monthly_interest: 'Monthly Interest',
        bill_to: 'Bill To',
        terms: 'TERMS & CONDITIONS',
        terms_details:
          'PAYMENT IS DUE IMMEDIATELY UPON SIGNATURE OF CONTRACT. ANY AMOUNT UNPAID WHEN DUE WILL BEAR INTEREST AT THE RATE OF 1% PER MONTH OR 12% PER YEAR.',
        invoice_subtotal: 'INVOICE SUBTOTAL',
        invoice_total: 'INVOICE TOTAL',
        paid: 'PAID',
        amount_due: 'AMOUNT DUE',
        category: 'CATEGORY',
        amount: 'AMOUNT',
        Casket: 'Casket',
        Disbursements: 'Disbursements',
        "Funeral Services": 'Funeral Services',
        "Religious Services": 'Religious Services',
        "Religious Goods": 'Religious Goods',
        Transportation: "Transportation",
        Opening: "Balance Owed",
      },
      invoice_created: 'Invoice created',
      add: 'Add Invoice',
    },
    creditmemos: {
      name: 'Credit Memo |||| Credit Memos',
      add: 'Credit Memo',
      creditmemo_created: 'Credit Memo created',
      pdf_success:
      'Success opening the credit memo in a new tab',
      pdf_error: 'Error printing credit memo',
      fields: {
        TxnDate: 'Date',
        TotalAmt: 'Total Amount',
      },
      print:{
        amount: 'Amount Credited',
        tax: 'Tax', 
        date: 'Date Credited',
        receipt: 'CREDIT RECEIPT'
      }
    },
    payments: {
      name: 'Payment |||| Payments',
      buttonAdd: 'Add a payment',
      buttonEdit: 'Edit Payment',
      receipt: 'Receipt',
      methods: {
        credit_card: 'Credit Card',
        cheque: 'Cheque',
        etransfer: 'E-Transfer',
        cash: 'Cash',
        wire: 'Wire',
        other: 'Other',
      },
      fields: {
        created_at: 'Create At',
        amount: 'Amount',
        method: 'Method',
        reference: 'Reference / Batch #',
        payment_date: 'Payment Date',
        payer: 'Payer',
        note: 'Note',
      },
      print: {
        receipt: 'PAYMENT RECEIPT',
        payor: 'Payor Name',
        contract_no: 'Contract No',
        payment_no: 'Payment No',
        date: 'Payment Date',
        deceased: 'Deceased Name',
        amount: 'Payment Amount',
        total_amount: 'Total Amount of Service',
        service_number: 'Service No',
      },
      created: 'Payment created',
      updated: 'Payment updated',
    },
    clergy: {
      _error: 'Error opening clergy report',
    },
    funerals: {
      name: 'Funeral |||| Funerals',
      title: 'Funeral %{id}',
      schedule: 'Schedule',
      shedule_error: 'Error opening schedule',
      clergy: 'Clergy',
      date: 'Funeral Date',
      owner: 'Owner',
      workorder: 'Work Order',
      director: 'Director',
      website: 'Publish to Website',
      _error: 'Error opening report',
      primary_required:
        'Contracts exist. Please check with accounting before making any changes to Primary Client.',
      missingDataSms: {
        title: 'Request Missing Information via SMS',
        copyButton: 'Copy Message',
        copiedSuccess: 'Message copied to clipboard',
        copiedError: 'Failed to copy message',
        allFieldsComplete: 'All fields are complete - no message needed',
        recipient: 'Recipient',
        phone: 'Phone',
        missingFields: '%{dec} DEC fields, %{benefits} Benefits fields missing',
        loadingMessage: 'Loading message...',
        errorLoading: 'Error loading message',
      },
      fieldGroups: {
        client: 'Client',
        clients: 'Clients',
        basicInfo: 'Basic Information',
        funeralInfo: 'Funeral Information',
        shivaInfo: 'Shiva Information',
        additionalInfo: 'Additional Information',
        primaryClient: 'Primary Client',
        files: 'Files',
        shiva_private: {
          none: 'No Shiva',
          open: 'Open',
          private: 'Private',
          strict: 'Strictly Private',
        },
        shroud: {
          none: 'No Shroud',
          linen: 'Linen',
          cotton: 'Cotton',
        },
      },
      certificate:{
        certificate: 'Certificate',
        _error: 'Error opening certificate',
        funeral_directors: 'DIRECTEURS DE FUNÉRAILLES - FUNERAL DIRECTORS',
        preuve: 'Preuve d\'inhumation CERTIFIÉE',
        proof: 'CERTIFIED proof of burial',
        number: 'N°',
        sp3: 'SP-3 N°',
        deceased: 'Défunte(e) (Deceased)',
        place_of_birth: 'Lieu de naissance (Place of birth)',
        residence: 'Domicile (Residence)',
        father: 'Père (Father)',
        mother: 'Mère (Mother)',
        spouse: 'Conjoint (Spouse)',
        doctor: 'Médecin (Doctor)',
        place_of_death: 'Lieu du décès (Place of death)',
        place_of_burial: 'Lieu d\'inhumation (Place of burial)',
        date_of_death: 'Date du décès (Death)',
        date_of_birth: 'Date de naissance (DOB)',
        age: 'Âge',
        cause: 'Cause',
        permit_number: 'Permis no.',
        date: 'Date',
        certified_by: 'Certifié par (Certified by)',
        attestation_fr: 'L\'attestation de la déclaration de décès de la personne mentionnée a été présentée au:',
        attestation_en: 'A declaration of death (SP3 Form) of the above mentioned has been file with:',
        bureau: 'BUREAU DE LA STATISTIQUE, 117, RUE ST-ANDRÉ, VILLE DE QUÉBEC, QC, G1K 3Y3',
        sex: 'Sex',
        marital_status: 'État civil (Marital Status)',
      },
      yahrzeit: {
        calendar: 'Yahrzeit Calendar',
        yahrzeit: 'Yahrzeit'
      },
    },
    places: {
      fieldGroups: {
        synagogue: 'Synagogue',
        hospital: 'Hospital',
        cemetery: 'Cemetery',
        section: 'Cemetery Section',
      },
    },
    attachments: {
      download: 'Download',
    },
    events: {
      name: "Log |||| Log",
      fields: {
        date: "Date",
        author: "Author",
        resource: "Resource",
        action: "Action",
      }
    }
  },
  utils: {
    english_language: 'English',
    french_language: 'French',
    show: 'Show',
    information: 'General information',
  },
  login: {
    title: 'Paperman and Sons',
    button: 'Login using Google account',
    failed: 'Login failed',
    loginSuccessful: 'Login successful',
  },
  'ra-supabase': {
    'auth': {
      sign_in_with: 'Sign In with Google',
    },
  },
  'ra-audit-log': {
    funerals: {
      record_event: {
        create: 'Created this resource',
        delete: 'Deleted this resource',
        update: 'ADS2222AD field %{fields} |||| Updated fields %{fields}',
    },
    record_many_fields_events: {
        create: 'Created this resource',
        delete: 'Deleted this resource',
        update: 'ADSA12222SDDAS field %{fields} and 1 other |||| Updated fields %{fields} and %{smart_count} others',
    },

    },
    record_event: {
        create: 'Created this resource',
        delete: 'Deleted this resource',
        update: 'Updated field %{fields} |||| Updated fields %{fields}',
    },
    record_many_fields_events: {
        create: 'Created this resource',
        delete: 'Deleted this resource',
        update: 'Updated fields %{all_fields}',
    },
  },
};

export default englishMessages;
